// import logo from './logo.svg';
import '../../App.scss';
import React, { useEffect, useState } from "react";
import Banner from './main-banner/Banner.js';
import Navbar from './header/Navbar.js';
import Cryptoinvesting from './cryptoinvesting/Cryptoinvesting.js';
import Core from './core/Core.js';
import Balanced from './balanced/Balanced.js';
import Markets from './markets/Markets.js';
import Team from './team/Team.js';
import Win from './win/Win.js';
import Position from './position/Position.js';
import Exchange from './exchange/Exchange.js';




function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  
   
  const [totalMarketCap, setTotalMarketCap] = useState(0);


  return (
    <>
      <Navbar />
      <Banner totalMarketCap={totalMarketCap} />
      <Exchange totalMarketCap={totalMarketCap} setTotalMarketCap={setTotalMarketCap} />
      <Cryptoinvesting />
      <Core />
      <Balanced />
      <Markets />
      <Team />
      <Win />
      <Position />


    </>
  );
}

export default Landing;